<template>
  <div class="added-docs" data-testid="added-docs">

    <slot>
      <div class="empty-state">
        <span class="empty-state__text">
          {{$t('client.share_dialog.selected.empty_state')}}
        </span>
      </div>
    </slot>

  </div>
</template>

<script>
export default {
  name: 'AddedDocs',
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.added-docs {
  overflow-y: auto;
  min-height: 172px;
  max-height: 250px;
  margin-top: 16px;
}

.empty-state {
  min-height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;

  &__text {
    color: $grey-color-23;
    font-weight: 400;
    font-size: 13px;
    line-height: 24px;
  }
}
</style>
